/**
 * @generated SignedSource<<e015fd994afb82473574ca4148beeff5>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type build_build$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type MyBuilds_viewer$fragmentType: FragmentType;
export type MyBuilds_viewer$data = {|
  +user: ?{|
    +builds?: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +$fragmentSpreads: build_build$fragmentType,
        |},
      |}>,
    |},
    +id: string,
    +runningBuilds?: ?{|
      +count: number,
    |},
    +scheduledBuilds?: ?{|
      +count: number,
    |},
  |},
  +$fragmentType: MyBuilds_viewer$fragmentType,
|};
export type MyBuilds_viewer$key = {
  +$data?: MyBuilds_viewer$data,
  +$fragmentSpreads: MyBuilds_viewer$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeBuildCounts"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeBuilds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyBuilds_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "condition": "includeBuilds",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 5
                }
              ],
              "concreteType": "BuildConnection",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BuildEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Build",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "build_build"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "builds(first:5)"
            }
          ]
        },
        {
          "condition": "includeBuildCounts",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "runningBuilds",
              "args": [
                {
                  "kind": "Literal",
                  "name": "state",
                  "value": [
                    "RUNNING",
                    "FAILING"
                  ]
                }
              ],
              "concreteType": "BuildConnection",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "builds(state:[\"RUNNING\",\"FAILING\"])"
            },
            {
              "alias": "scheduledBuilds",
              "args": [
                {
                  "kind": "Literal",
                  "name": "state",
                  "value": "SCHEDULED"
                }
              ],
              "concreteType": "BuildConnection",
              "kind": "LinkedField",
              "name": "builds",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "builds(state:\"SCHEDULED\")"
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "2b465ab87a77bc58f8eda3bdd818038f";

module.exports = ((node/*: any*/)/*: Fragment<
  MyBuilds_viewer$fragmentType,
  MyBuilds_viewer$data,
>*/);
